export default "__VITE_ASSET__CQHLv7D8__"